<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#receiptNotePanel' }"
    [visible]="busy"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
>
</dx-load-panel>
<div #receiptNotePanel class="main dx-card padding-content">
    <dx-box direction="row" crossAlign="center">
        <dxi-item [ratio]="9" style="text-align: start">
            <span style="font-size: x-large">ใบเสร็จรับเงิน (Marketplace)</span>
        </dxi-item>
        <dxi-item [ratio]="2" style="padding-right: 10px; text-align: right">
            <dx-button
                [disabled]="busy"
                stylingMode="outlined"
                text="Clear"
                icon="clear"
                type="danger"
                width="100%"
                (onClick)="clearForm()"
            ></dx-button>
        </dxi-item>
        <dxi-item [ratio]="3" style="padding-right: 10px">
            <dx-button
                [disabled]="busy"
                stylingMode="contained"
                text="Preview PDF"
                icon="pdffile"
                type="normal"
                width="100%"
                (onClick)="previewPdf()"
            ></dx-button>
        </dxi-item>
        <dxi-item [ratio]="3" style="padding-right: 10px">
            <dx-button
                [disabled]="busy"
                stylingMode="contained"
                [text]="'Download ' + fileFormatLabel"
                [icon]="fileFormat === 'jpg' ? 'image' : 'download'"
                type="normal"
                width="100%"
                (onClick)="downloadFile()"
            ></dx-button>
        </dxi-item>
        <dxi-item [ratio]="3">
            <dx-button
                [disabled]="busy"
                stylingMode="contained"
                [text]="'Save / Share ' + fileFormatLabel"
                icon="save"
                type="default"
                width="100%"
                (onClick)="saveAndShare()"
            ></dx-button>
        </dxi-item>
    </dx-box>
    @if (shareData) {
        <dx-box direction="row" crossAlign="center" style="margin-top: 10px">
            <dxi-item [ratio]="2" style="padding-right: 10px">
                <dx-text-box
                    width="100%"
                    label="File Name"
                    [value]="shareData.fileName"
                    [readOnly]="true"
                    style="margin-bottom: 7px"
                >
                </dx-text-box>
            </dxi-item>
            <dxi-item [ratio]="8" style="padding-right: 10px">
                <dx-text-box
                    width="100%"
                    label="Shared URL"
                    [value]="shareData.sharedUrl"
                    [readOnly]="true"
                    style="margin-bottom: 7px"
                ></dx-text-box>
            </dxi-item>
            <dxi-item [ratio]="1" style="padding-right: 10px">
                <dx-button
                    [disabled]="busy"
                    stylingMode="contained"
                    text="Copy"
                    icon="copy"
                    width="100%"
                    (onClick)="copySharedUrlToClipboard()"
                ></dx-button>
            </dxi-item>
            <dxi-item [ratio]="1">
                <dx-button
                    [disabled]="busy"
                    stylingMode="contained"
                    text="Open"
                    icon="link"
                    width="100%"
                    (onClick)="openSharedUrl()"
                ></dx-button>
            </dxi-item>
        </dx-box>
    }

    <div class="section-header" style="margin-top: 10px">คำสั่งซื้อ</div>
    <div class="flex-container-row" style="align-items: center">
        <div style="flex-basis: 50%">
            <dx-text-box
                [(value)]="inputValues.source.orderNo"
                [showClearButton]="true"
                labelMode="floating"
                label="เลขที่คำสั่งซื้อ (Order No.)"
                valueChangeEvent="input"
                (onEnterKey)="loadOrder()"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div style="flex-basis: 25%">
            <dx-select-box
                [(value)]="inputValues.source.storeId"
                [items]="stores"
                displayExpr="title"
                valueExpr="storeId"
                placeholder="ค้นหาทุกร้านอัตโนมัติ"
                [showClearButton]="true"
                label="ร้านค้า (ไม่บังคับ)"
                labelMode="floating"
                (onValueChanged)="onStorePicked($event)"
            ></dx-select-box>
        </div>
        <div style="flex-basis: 25%; flex-grow: 0">
            <dx-button
                [disabled]="busy"
                stylingMode="contained"
                text="Load Order"
                icon="download"
                type="default"
                width="100%"
                (onClick)="loadOrder()"
            ></dx-button>
        </div>
    </div>
    @if (loadedOrder) {
        <div class="loaded-banner">
            <span class="bold">{{ loadedOrder.platform | uppercase }}</span>
            order <span class="bold">{{ loadedOrder.orderNo }}</span>
            @if (loadedOrder.createdIsoDate) {
                <span>· created {{ loadedOrder.createdIsoDate }}</span>
            }
            @if (loadedOrder.paymentMethod) {
                <span>· {{ loadedOrder.paymentMethod }}</span>
            }
            <span>
                · customer from
                @if (loadedOrder.customerSource === "billing-request") {
                    <span class="user-input"
                        >the customer’s billing request</span
                    >
                } @else {
                    <span
                        >platform data
                        @if (loadedOrder.platform !== "lazada") {
                            <span class="warn"> (masked — overtype it)</span>
                        }
                    </span>
                }
            </span>
            <span
                >· file format
                <span class="bold">{{ fileFormatLabel }}</span></span
            >
        </div>
    }

    <div class="section-header">ข้อมูลเอกสาร</div>
    <div class="flex-container-row">
        <div style="flex-basis: 16%">
            <dx-date-box
                label="วันที่"
                labelMode="floating"
                displayFormat="dd MMMM yyyy"
                dateSerializationFormat="yyyy-MM-dd"
                [showClearButton]="true"
                [disabled]="inputValues.docInfo.hideDate"
                [(value)]="inputValues.docInfo.date"
                (onValueChanged)="onInputsUpdated()"
                [calendarOptions]="{ showTodayButton: true }"
            >
            </dx-date-box>
        </div>
        <div class="checkbox-container" style="flex-basis: 22%">
            <dx-switch
                [(value)]="inputValues.docInfo.hideDate"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-switch>
            &nbsp;<span
                [ngClass]="{
                    'user-input': inputValues.docInfo.hideDate,
                }"
                >เว้นวันที่ว่าง</span
            >
        </div>
        <div style="flex-basis: 28%">
            <dx-text-box
                [(value)]="inputValues.docInfo.customTitle"
                [showClearButton]="true"
                labelMode="floating"
                label="เปลี่ยนหัวเอกสาร (ว่าง = ใบเสร็จรับเงิน ( Receipt Note ))"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div class="checkbox-container" style="flex-basis: 20%">
            <dx-switch
                [(value)]="inputValues.docInfo.showSellerSignature"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-switch>
            &nbsp;<span
                [ngClass]="{
                    'user-input': inputValues.docInfo.showSellerSignature,
                }"
                >ประทับลายเซ็นผู้รับเงิน</span
            >
        </div>
        <div class="checkbox-container" style="flex-basis: 12%">
            <dx-switch
                [(value)]="inputValues.docInfo.hideLogo"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-switch>
            &nbsp;<span
                [ngClass]="{
                    'user-input': inputValues.docInfo.hideLogo,
                }"
                >ซ่อนโลโก้</span
            >
        </div>
    </div>

    <div class="section-header">ข้อมูลผู้ซื้อ</div>
    <div class="finder-launcher">
        <dx-button
            [disabled]="busy"
            stylingMode="outlined"
            text="ค้นหาบริษัท"
            icon="search"
            type="default"
            (onClick)="openCounterpartyFinder()"
        ></dx-button>
    </div>
    <div class="flex-container-row">
        <div style="flex-grow: 5">
            <dx-text-box
                [(value)]="inputValues.customerInfo.name"
                [showClearButton]="true"
                labelMode="floating"
                label="ชื่อ"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div style="flex-grow: 1">
            <dx-text-box
                [(value)]="inputValues.customerInfo.taxId"
                [showClearButton]="true"
                labelMode="floating"
                label="เลขประจำตัวผู้เสียภาษี (ว่าง = ไม่พิมพ์)"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-box>
        </div>
        <div style="flex-grow: 1">
            <dx-select-box
                [(value)]="inputValues.customerInfo.branch"
                [items]="branchList"
                placeholder="เลือกสาขา"
                [showClearButton]="true"
                label="สาขา"
                labelMode="floating"
                [acceptCustomValue]="true"
                (onValueChanged)="onInputsUpdated()"
            ></dx-select-box>
        </div>
    </div>
    <div class="flex-container-row">
        <div>
            <dx-text-area
                [(value)]="inputValues.customerInfo.address"
                [height]="60"
                labelMode="floating"
                label="ที่อยู่"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-area>
        </div>
    </div>

    <div class="section-header">รายการสินค้า</div>
    <div class="flex-container-row" style="margin-bottom: 10px">
        <dx-data-grid
            #dataGrid
            class="dx-card"
            style="padding-top: 10px"
            keyExpr="itemNo"
            [showBorders]="false"
            [columnAutoWidth]="false"
            [allowColumnResizing]="true"
            [dataSource]="inputValues.items"
            (onSaved)="onSaved()"
        >
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-editing
                mode="batch"
                [allowUpdating]="true"
                [allowDeleting]="true"
                [allowAdding]="true"
                [selectTextOnEditStart]="true"
                newRowPosition="last"
            >
            </dxo-editing>
            <dxo-row-dragging
                [allowReordering]="true"
                [onReorder]="onReorder"
            ></dxo-row-dragging>
            <dxi-column
                dataField="itemNo"
                caption="No."
                dataType="number"
                [width]="70"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column
                dataField="description"
                caption="Description"
                [minWidth]="160"
            ></dxi-column>
            <dxi-column
                dataField="unitPrice"
                caption="Unit Price"
                dataType="number"
                [format]="{ type: 'fixedPoint', precision: 2 }"
                [width]="130"
                [setCellValue]="setUnitPrice"
            ></dxi-column>
            <dxi-column
                dataField="quantity"
                caption="Quantity"
                dataType="number"
                [width]="110"
                [setCellValue]="setQuantity"
            ></dxi-column>
            <dxi-column
                dataField="amount"
                caption="Amount"
                dataType="number"
                [format]="{ type: 'fixedPoint', precision: 2 }"
                [width]="140"
                [allowEditing]="false"
            ></dxi-column>
        </dx-data-grid>
    </div>

    <div class="section-header">ยอดเงิน</div>
    <div class="flex-container-row">
        <div style="flex-basis: 25%">
            <dx-text-box
                [value]="total | formatNumber: 2"
                [readOnly]="true"
                labelMode="floating"
                label="ราคารวม / Total"
            >
            </dx-text-box>
        </div>
        <div style="flex-basis: 25%">
            <dx-number-box
                [(value)]="inputValues.amounts.discount"
                [min]="0"
                [format]="{ type: 'fixedPoint', precision: 2 }"
                [showClearButton]="true"
                labelMode="floating"
                label="ส่วนลด / Discount"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-number-box>
        </div>
        <div style="flex-basis: 25%">
            <dx-number-box
                [(value)]="inputValues.amounts.shippingCost"
                [min]="0"
                [format]="{ type: 'fixedPoint', precision: 2 }"
                [showClearButton]="true"
                labelMode="floating"
                label="ค่าส่งสินค้า / Shipping Cost"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-number-box>
        </div>
        <div style="flex-basis: 25%">
            <dx-text-box
                class="net-price"
                [value]="net | formatNumber: 2"
                [readOnly]="true"
                labelMode="floating"
                label="จำนวนเงินรวมสุทธิ / Net Price"
            >
            </dx-text-box>
        </div>
    </div>

    <div class="section-header">อื่นๆ</div>
    <div class="flex-container-row">
        <div>
            <dx-text-area
                [(value)]="inputValues.docInfo.remark"
                [height]="60"
                labelMode="floating"
                label="หมายเหตุ (ว่าง = ไม่พิมพ์)"
                (onValueChanged)="onInputsUpdated()"
            >
            </dx-text-area>
        </div>
    </div>
</div>

<!-- The company lookup lives in a popup: a name search can return dozens of
     companies, and inline they pushed the rest of the form off the screen.
     Pinned to the top so the search box stays put while the results grow
     beneath it; past the max height the popup scrolls, not the page. -->
<dx-popup
    [(visible)]="finderPopupVisible"
    [showTitle]="true"
    title="ค้นหาบริษัท — เลขประจำตัวผู้เสียภาษีหรือชื่อบริษัท"
    [dragEnabled]="true"
    [hideOnOutsideClick]="true"
    [showCloseButton]="true"
    [width]="720"
    height="auto"
    [maxHeight]="'85vh'"
    [position]="{ my: 'top', at: 'top', offset: '0 40' }"
    (onShown)="counterpartyFinder.focusInput()"
>
    <app-counterparty-finder
        #counterpartyFinder
        (ctpSelectionChangeEvent)="onCounterpartySelected($event)"
    ></app-counterparty-finder>
</dx-popup>
